module.exports = __webpack_public_path__ + "dd45aea0028f808a5b63630044c072eb.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/screenprint-hoodie-turquoise.png
// module id = 806
// module chunks = 0